import Request from 'modules/Finance/PromisedPayment/Request/Request'

export default Request
